// extracted by mini-css-extract-plugin
export default {"leftfix":"reset_leftfix__VK09q","rightfix":"reset_rightfix__dasKh","clearfix":"reset_clearfix__KPER2"};